import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../../components/layout/AppLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { 
  MessageCircle, 
  UserPlus, 
  Users,
  ChevronRight,
  Sparkles
} from 'lucide-react';

export const SocialPage = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Matrise Connect',
      icon: Sparkles,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50 dark:bg-blue-950',
      items: [
        { label: 'Matrise Connect', path: '/connect/feed', icon: Sparkles, description: 'Public feed, messages & more' },
      ]
    },
    {
      title: 'Connections',
      icon: UserPlus,
      color: 'text-green-600',
      bgColor: 'bg-green-50 dark:bg-green-950',
      items: [
        { label: 'My Contacts', path: '/user/contacts', icon: UserPlus },
      ]
    },
    {
      title: 'Community',
      icon: Users,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50 dark:bg-purple-950',
      items: [
        { label: 'Groups & Stokvels', path: '/user/groups', icon: Users },
      ]
    },
  ];

  return (
    <AppLayout>
      <div className="p-4 space-y-6">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Social</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Connect with people and community
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {sections.map((section) => {
            const SectionIcon = section.icon;
            return (
              <Card key={section.title}>
                <CardHeader className="pb-3">
                  <div className="flex items-center gap-3">
                    <div className={`${section.bgColor} p-2 rounded-lg`}>
                      <SectionIcon className={`h-5 w-5 ${section.color}`} />
                    </div>
                    <CardTitle className="text-lg">{section.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="space-y-2">
                  {section.items.map((item) => {
                    const ItemIcon = item.icon;
                    return (
                      <button
                        key={item.label}
                        onClick={() => navigate(item.path)}
                        className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-left"
                      >
                        <div className="flex items-center gap-3">
                          <ItemIcon className="h-4 w-4 text-gray-600 dark:text-gray-400" />
                          <div>
                            <div className="flex items-center gap-2">
                              <span className="text-sm font-medium text-gray-900 dark:text-white">
                                {item.label}
                              </span>
                              {item.badge && (
                                <span className="px-2 py-0.5 text-xs font-semibold bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full">
                                  {item.badge}
                                </span>
                              )}
                            </div>
                            {item.description && (
                              <p className="text-xs text-gray-500">{item.description}</p>
                            )}
                          </div>
                        </div>
                        <ChevronRight className="h-4 w-4 text-gray-400" />
                      </button>
                    );
                  })}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
};
